// import pages
import React, { useState, useEffect } from "react";
import FooterB from "../layout/FooterB";
import SubHeader from "../layout/SubHeader";
import SubFooter from "../layout/SubFooter";
import HeroSection from "../layout/HeroSection";
import Registration from "./Registration";
import { getRegisterPage } from "../../sanityClient";

// import style
import "../../style/pages/auth/register.scss";

const componentMap = {
  heroSection: HeroSection,
  simpleIndexSection: Registration,
  footerB: FooterB,
  subHeader: SubHeader,
  subFooter: SubFooter,
};

const Register = () => {
  const [pageData, setPageData] = useState({
    pageSections: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const data = await getRegisterPage();
        if (data) {
          setPageData(data);
        }
      } catch (error) {
        console.error("Error fetching page data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPageData();
  }, []);

  const renderSection = (section, index) => {
    const SectionComponent = componentMap[section._type];

    if (!SectionComponent) {
      console.warn(`Unknown section type: ${section._type}`);
      return null;
    }

    switch (section._type) {
      case 'heroSection':
        return (
          <SectionComponent
            key={section._key || index}
            title={section.title}
            subTitle={section.subTitle}
            backgroundColorClass={section.backgroundColorClass}
            linkPath={section.linkPath}
            enContent={section.enContent}
            jpContent={section.jpContent}
            questionLinkText={section.questionLink}
            questionLinkJpText={section.questionLinkJp}
          />
        );
      case 'simpleIndexSection':
        return (
          <SectionComponent
            key={section._key || index}
            title={section.title}
            titleJP={section.titleJP}
            content={section.content}
          />
        );
      case 'footerB':
        return <SectionComponent key={section._key || index} />;
      case 'subHeader':
        return (
          <SectionComponent
            key={section._key || index}
            title={section.title}
            backgroundColorClass={section.backgroundColorClass}
          />
        );
      case 'subFooter':
        return (
          <SectionComponent
            key={section._key || index}
            title={section.title}
            backgroundColorClass={section.backgroundColorClass}
          />
        );
      default:
        return null;
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="register-section">
      {pageData.pageSections && pageData.pageSections.length > 0 ? (
        pageData.pageSections.map((section, index) => renderSection(section, index))
      ) : (
        <>
          <div className="error-container container main-section">
            <div className="responsive-main-section">
              <div className="title-section background-red">
                <div className="title-link">
                  <div className="title font-amaticsc-bold">Oops!</div>
                  <div className="sub-title font-zenkurenaido">おっと！</div>
                </div>
              </div>
              <div className="content-section">
                <div className="en-content font-outfit-bold">
                  <span>Something went wrong while loading the page. Please try again later.</span>
                  <span>Have a question for Ben-sensei? Feel free to ask it <a href="/question" className="en-question-link">here!</a></span>
                </div>
                <div className="jp-content font-kleeone">
                  <span>ページの読み込み中に問題が発生しました。しばらくしてからもう一度お試しください。</span>
                  <span>ベン先生に質問がありますか？ ぜひ<a href="/question" className="jp-question-link">こちらから</a>質問してください！</span>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Register;
